import request from '@/utils/request'


export function save(form) {
  return request({
    url: 'product-measurement/save',
    method: 'post',
    data: form
  });
}

export function update(form) {
  return request({
    url: 'product-measurement/update',
    method: 'put',
    data: form
  });
}

export function getAll() {
  return request({
    url: 'product-measurement/getAll',
    method: 'get',
  });
}

export function destroy(id) {
  return request({
    url: 'product-measurement/destroy/' + id,
    method: 'delete',
  });
}
